import { render, staticRenderFns } from "./WarehouseBenefits.vue?vue&type=template&id=3ea1238b&scoped=true&"
import script from "./WarehouseBenefits.vue?vue&type=script&lang=js&"
export * from "./WarehouseBenefits.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseBenefits.vue?vue&type=style&index=0&id=3ea1238b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea1238b",
  null
  
)

export default component.exports